module.exports = __webpack_public_path__ + "static/media/Configuración_Contraseñas.df69372e.svg";